import { render } from "./SkillComp.vue?vue&type=template&id=0a3f3bcc&scoped=true"
import script from "./SkillComp.vue?vue&type=script&lang=js"
export * from "./SkillComp.vue?vue&type=script&lang=js"

import "./SkillComp.vue?vue&type=style&index=0&id=0a3f3bcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3f3bcc"]])

export default __exports__